import { useKycContext } from '../context';
import { IdnowLoading } from './idnow-loading';
import { FourthlineLoading } from './fourthline-loading';

export function KycPageLoading(): React.ReactNode {
  const { legalCountry } = useKycContext();
  return legalCountry === 'DE' ? <IdnowLoading /> : <FourthlineLoading />;
}
